<div fxLayout>
  <main fxFlex style="padding: 0px; margin-bottom: 0">
    <picture>
      <source srcset="assets/images/demo/calendar/calendar.webp" type="image/webp" />
      <img src="assets/images/demo/calendar/calendar.svg" class="demo-ux-image" (load)="isImageLoaded = true" />
    </picture>

    <div class="demo-callout rules__intro-text" *ngIf="isImageLoaded">
      <ng-container *ngIf="userTrialConnectAccountCta$ | async as userTrialConnectAccountCta">
        <h2>One calendar to rule them all!</h2>
        <p class="notification__description">
          The Hospitable.com calendar allows you to show data from all platforms you have connected so you can be on top
          of everything without having to look for information in various places.
        </p>
        <p class="notification__description">
          Connect your {{ userTrialConnectAccountCta?.platformUi | titlecase }} account to import your listings into
          your Hospitable.com account and start using the calendar today!
        </p>

        <div class="rules__intro-buttons" fxLayout fxLayout.lt-md="column" fxLayoutGap="16px">
          <button mat-flat-button (click)="clickedPrimaryCta(userTrialConnectAccountCta.connectAccountUrl)">
            Connect with {{ userTrialConnectAccountCta?.platformUi | titlecase }}
          </button>

          <a
            mat-flat-button
            class="button__secondary"
            (click)="
              clickedSecondaryCta(
                'https://my.hospitable.com/support-documentation/article/5625442-getting-started-with-the-calendar'
              )
            ">
            Learn more
          </a>
        </div>
      </ng-container>
    </div>
  </main>
</div>
